module.exports = __webpack_public_path__ + "r-v3/img/ml_16_00.fa666953.jpg";